///<reference path="./ListLevel.js"/>

const MOVE_DIRECTION = {
  UP: "up",
  DOWN: "down",
  BY_NAME: "by name"
};

const BLOCK_TYPE = {
  UNDEFINED: "UNDEFINED",
  PARAGRAPH: "PARAGRAPH",
  NESTED_PARAGRAPH: "NESTED_PARAGRAPH",
  LIST_ITEM: "LIST_ITEM",
  INSERTED_LIST_ITEM: "INSERTED_LIST_ITEM",
  INSERTED_LIST_ITEM_PARAGRAPH: "INSERTED_LIST_ITEM_PARAGRAPH",
  INSERTED_LIST_ITEM_SUB_PARAGRAPH: "INSERTED_LIST_ITEM_SUB_PARAGRAPH",
  INSERTED_LIST_ITEM_UL_PARAGRAPH: "INSERTED_LIST_ITEM_UL_PARAGRAPH"
};

// Same rule window.filterVisible applies: an element is invisible when it, or any
// ancestor, carries one of these classes.
const HIDDEN_BLOCK_SELECTOR =
  ".lp-hide-element,.deleted-element,.deleted-container";

const VISIBLE_BLOCK_TAG_NAMES = ["P", "H1", "H2", "H3", "H4", "H5", "H6", "DIV"];

// Steps through [pid] elements in document order, starting from wherever the
// caller parks currentNode. Rejecting a hidden container skips its entire subtree
// in a single step -- the work filterVisible does by running closest() against
// every [pid] element in the document, whether or not the answer is nearby.
function createVisiblePidWalker() {
  return document.createTreeWalker(
    document.documentElement,
    NodeFilter.SHOW_ELEMENT,
    {
      acceptNode: function(node) {
        if (node.matches(HIDDEN_BLOCK_SELECTOR)) {
          return NodeFilter.FILTER_REJECT;
        }

        return node.hasAttribute("pid")
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_SKIP;
      }
    }
  );
}

// True when the node would have shown up in querySelectorAll('[pid]', true).
// The containing node is not always a [pid] element -- see the constructor's
// fallback to a free-text parent -- and the two lookups below each have their own
// established behaviour for that case.
function isVisiblePidElement(node) {
  return !!(
    node &&
    node.nodeType === Node.ELEMENT_NODE &&
    node.hasAttribute("pid") &&
    node.closest(HIDDEN_BLOCK_SELECTOR) === null
  );
}

function Block(data, node, $scope, $q, LeaseEditorService, $compile) {
  this.containingNode = null;
  this.counter = null;
  this.currentIndex = null;
  this.format = null;
  this.formatUpdate = null;
  this.level = null;
  this.levelCounters = null;
  this.levelName = null;
  this.list = null;
  this.listLevel = null;
  this.node = null;
  this.outline = null;
  this.reset = null;
  this.setHeading = null;
  this.setLevel = null;
  this.skip = null;
  this.static = null;
  this.tableNode = null;
  this.vcNotInUse = null;
  this.$scope = $scope;
  this.$q = $q;
  this.LeaseEditorService = LeaseEditorService;
  this.$compile = $compile;
  this.sourceNode = node;
  this.isAutoNumber = null;
  this.blockType = BLOCK_TYPE.UNDEFINED;
  this.isSectionEnd = null;

  if (data) {
    Object.keys(data).forEach(key => {
      if (key in this) {
        if (key === "listLevel" && data[key]) {
          this[key] = new ListLevel(data[key]);
        } else {
          this[key] = data[key];
        }
      } else {
        if (key !== "$$hashKey" && window.isDebug) {
          console.error(
            `Error creating ListItem could not find key ${key} in object`
          );
        }
      }
    });

    if (this.tableNode) {
      let numberElement = this.tableNode.querySelector("[list]");
      let spaceElement;

      if(numberElement.getAttribute('list') === ""){
        numberElement = null;
      }

      if (
        numberElement &&
        numberElement.nextElementSibling &&
        numberElement.nextElementSibling.style.fontSize === "7pt"
      ) {
        spaceElement = numberElement.nextElementSibling;
      }

      if (numberElement) {
        const pidElement = this.sourceNode.closest("[pid]");
        if (!pidElement.contains(numberElement)) {
          this.tableNode = null;
        }
      }
      else{
        this.tableNode = null;
      }
    }
  } else {
    this.containingNode = this.sourceNode.closest("[pid]");
    if(!this.containingNode ){
      const freeTexts = this.sourceNode.querySelectorAll('[free-text]');
      if(freeTexts.length === 1){
        this.containingNode = freeTexts[0].parentElement;
      }
      
    }
  }

  function getBlockType() {
    if (
      !data ||
      (data.level === -1 &&
        !data.containingNode.classList.contains("inserted-list-item"))
    ) {
      if (
        this.sourceNode.hasAttribute("data-nested-paragraph-index") ||
        this.sourceNode.closest("[data-nested-paragraph-index]")
      ) {
        this.blockType = BLOCK_TYPE.NESTED_PARAGRAPH;
        this.listLevel = null;
        this.outline = null;
      } else if (this.sourceNode.closest("[advanced-edit]")) {
        this.blockType = BLOCK_TYPE.NESTED_PARAGRAPH;
        this.listLevel = null;
        this.outline = null;
      } else {
        this.blockType = BLOCK_TYPE.PARAGRAPH;
        this.listLevel = new ListLevel(null, "paragraph");
        this.outline = this.containingNode ?  this.containingNode.getNodeOutline() : null;
        this.listLevel.outline = this.outline;
      }
    } else {
      const node = this.tableNode || this.containingNode;
      if (node.classList.contains("inserted-list-item")) {
        if (node.classList.contains("list-item-paragraph")) {
          this.blockType = BLOCK_TYPE.INSERTED_LIST_ITEM_PARAGRAPH;
          this.listLevel = new ListLevel(null, "paragraph");
          this.outline = this.containingNode.getNodeOutline();
          this.listLevel.outline = this.outline;
        } else if (node.classList.contains("list-item-sub-paragraph")) {
          this.blockType = BLOCK_TYPE.INSERTED_LIST_ITEM_SUB_PARAGRAPH;
          this.listLevel = new ListLevel(null, "sub-paragraph");
          this.outline = this.containingNode.getNodeOutline();
          this.listLevel.outline = this.outline;
        } else if (node.classList.contains("list-item-ul-paragraph")) {
          this.blockType = BLOCK_TYPE.INSERTED_LIST_ITEM_UL_PARAGRAPH;
          this.listLevel = new ListLevel(null, "ul-paragraph");
          this.outline = this.containingNode.getNodeOutline();
          this.listLevel.outline = this.outline;
        } else {
          this.blockType = BLOCK_TYPE.INSERTED_LIST_ITEM;
        }
      } else {
        this.blockType = BLOCK_TYPE.LIST_ITEM;
      }
    }
  }
  getBlockType.call(this);

  async function movePredefinedBlockToLevel(
    direction,
    LeaseEditorService,
    levelName,
    currentRestyle
  ) {
    const deferred = $q.defer();
    const newLevel = this.listLevel.getLevelByName(levelName);
    const objectIndex = this.getListItemObjectIndex();
    let itemObject = this.$scope.listItems[objectIndex];
    let insertedListItemId = this.getInsertedListItemId();
    const pid = this.containingNode.getAttribute("pid");
    let restyle =
      (levelName === "paragraph" || levelName === "normal")
        ? window.getRestyleObjectFromParagraph(this.containingNode, pid)
        : null;

      if(levelName === 'normal' && restyle){
        restyle = {...restyle , textIndent: 0,paragraphIndent:0};
      }

    if (!itemObject) {
      itemObject = {
        level: newLevel.level,
        outline: newLevel.outline,
        headerFreeText: null,
        bodyFreeText: null,
        afterFreeText: this.containingNode.getAttribute("pid"),
        fromUI: false,
        singleFT: true,
        isNewListItem: true,
        fromPID: true,
        index: this.containingNode.getNodeOccurrenceIndexByAttribute("pid")
      };

      this.$scope.listsNewListItem(null, itemObject, null, null, false);
    } else {
      itemObject.level = newLevel.level;

      let template = newLevel.getTemplate(
        itemObject,
        itemObject.json ? true : false
      );
      const freeTextArray = template.querySelectorAll("[free-text]");
      const freeTextArrayNumbers = [];
      freeTextArray.forEach(el => {
        freeTextArrayNumbers.push(el.getAttribute("free-text"));
      });

      await document.waitForFreeTextCompile(freeTextArrayNumbers, template);
        
      
      for (let index = 0; index < template.children.length; index++) {
        template.children[index].setAttribute(
          "inserted-list-item-id",
          insertedListItemId
        );
        template.children[index].classList.add(
          "lp-show-element",
          "lp-if-ignore",
          "inserted-list-item"
        );
      }

      
      while (template.childNodes.length !== 0) {
        let node = template.childNodes[template.childNodes.length - 1];
        node.remove();
        this.containingNode.parentElement.insertBefore(
          node,
          this.containingNode.nextElementSibling
        );
      }

      this.remove();

      setTimeout($scope.listsRefresh);
      
      
    }

    const newBlockElement = document.querySelector(`[pid="${pid}"]`);
    const newBlock = newBlockElement ? newBlockElement.getBlockData() : null;


    if (      
      levelName !== "paragraph" && levelName !== "normal"
    ) {
      delete $scope.lease.restyle[pid];
      restyle = null;
      this.$scope.restyle();
    }

    if (restyle) {
      this.$scope.lease.restyle[pid] = restyle;
      this.$scope.restyle();
    }

    if (newBlock) {
      newBlock.placeCaretAtStart();
    }

    deferred.resolve();
    return deferred.promise;
  }

  async function moveInsertedListItem(
    direction,
    LeaseEditorService,
    levelName,
    currentRestyle
  ) {
    const deferred = $q.defer();
    const container = this.tableNode || this.containingNode;
    const pid = container.getAttribute("pid");

    let itemObject = this.$scope.listItems[this.getListItemObjectIndex()];
    let freeTextToCompile = null;
    let newLevel = null;
    if (direction === MOVE_DIRECTION.UP) {
      newLevel = this.listLevel.getNextLevel();
    } else if (direction === MOVE_DIRECTION.DOWN) {
      newLevel = this.listLevel.getPreviousLevel();
    } else if (direction === MOVE_DIRECTION.BY_NAME) {
      newLevel = this.listLevel.getLevelByName(levelName);
    }

    itemObject.level = newLevel.level;
    itemObject.outline = newLevel.outline;
    itemObject.singleFT = true;
    let template = newLevel.getTemplate(itemObject);
    template.removeWhitespace();
    let insertedListItemId = this.getInsertedListItemId();

    for (let index = 0; index < template.children.length; index++) {
      template.children[index].setAttribute(
        "inserted-list-item-id",
        insertedListItemId
      );
      template.children[index].classList.add(
        "lp-show-element",
        "lp-if-ignore",
        "inserted-list-item"
      );
    }

    let currentItems = document.querySelectorAll(
      `[inserted-list-item-id="${insertedListItemId}"]`
    );
    let lastItemInDocument = currentItems[currentItems.length - 1];
    let listItemsInTemplate = template.querySelectorAll("[free-text]");
    let firstFreeText = null;

    for (let index = 0; index < listItemsInTemplate.length; index++) {
      let freeText = listItemsInTemplate[index];
      let documentFreeText = document.querySelector(
        `[free-text="${freeText.getAttribute("free-text")}"]`
      );

      if (index === 0) {
        firstFreeText = documentFreeText;
      }

      if (!documentFreeText && listItemsInTemplate.length === 1) {
        const docBodyFreeText = document.querySelector(
          `[free-text="${itemObject.bodyFreeText}"]`
        );
        const docHeaderFreeText = document.querySelector(
          `[free-text="${itemObject.headerFreeText}"]`
        );
        documentFreeText = docBodyFreeText || docHeaderFreeText;
        firstFreeText = documentFreeText;
      }

      if (documentFreeText) {
        documentFreeText.remove();
        freeText.parentElement.insertBefore(
          documentFreeText,
          freeText.nextElementSibling
        );
        freeText.remove();
      } else {
        freeTextToCompile = freeText;
      }
    }

    while (template.childNodes.length !== 0) {
      let node = template.childNodes[template.childNodes.length - 1];
      node.remove();
      lastItemInDocument.parentElement.insertBefore(
        node,
        lastItemInDocument.nextElementSibling
      );
    }

    setTimeout($scope.listsRefresh);

    currentItems.forEach(el => {
      el.remove();
    });

    let restyle = window.getRestyleObjectFromParagraph(container, pid);
    if(levelName === 'normal' && restyle){
      restyle = {...restyle , textIndent: 0,paragraphIndent:0};
    }
    
    if($scope.lease.restyle[pid] && levelName === 'normal'){
      $scope.lease.restyle[pid] = {...$scope.lease.restyle[pid],textIndent: 0,paragraphIndent:0}
    }

    if (
      this.blockType === BLOCK_TYPE.INSERTED_LIST_ITEM &&
      (levelName === "paragraph" || levelName === "normal" )
    ) {
      $scope.lease.restyle[pid] = restyle;
    } else if (
      this.blockType === BLOCK_TYPE.INSERTED_LIST_ITEM_PARAGRAPH &&
      levelName !== "paragraph" && levelName !== "normal"
    ) {
      delete $scope.lease.restyle[pid];
    }

    if (currentRestyle) {
      $scope.lease.restyle = JSON.parse(currentRestyle);
    }

    $scope.restyle();
    listItemsManager.createListItemsMap();

    if (freeTextToCompile) {
      let elScope = angular.element(freeTextToCompile).scope();
      this.$compile(freeTextToCompile)(elScope || this.$scope);
    }

    if (firstFreeText) {
      await document.waitForFreeTextCompile(
        firstFreeText.getAttribute("free-text")
      );

      setTimeout(() => {
        let span = firstFreeText.querySelector("[contenteditable]")
          .childNodes[0];
        span = LeaseEditorService.skipEmptyNodes(span, true);
        this.$scope.placeCaretAtStart(span);
      });
    }

    deferred.resolve();
    return deferred.promise;
  }

  function internalMoveToLevel(
    freeText,
    levelName,
    currentRestyle,
    $q,
    $scope,
    LeaseEditorService
  ) {
    return async function() {
      const blockData = freeText.getBlockData();
      const container = blockData.containingNode;
      const pid = container.getAttribute("pid");
      const before = container.innerText

      const deferred = $q.defer();
      const listItem = blockData;

      if (listItem.isInsertedListItem() && !listItem.isPredefinedBlock()) {
        await moveInsertedListItem.call(
          listItem,
          MOVE_DIRECTION.BY_NAME,
          LeaseEditorService,
          levelName,
          currentRestyle
        );
      } else {
        await movePredefinedBlockToLevel.call(
          listItem,
          MOVE_DIRECTION.BY_NAME,
          LeaseEditorService,
          levelName,
          currentRestyle
        );
      }

      $scope.lease.orderedListitem = $scope.serializeOrderedListitem();
      $scope.update();

      const after = freeText.getBlockData().containingNode.innerText;

      window.track.event(new ChangeLevelEvent({
        pid,
        before,
        after,
      }));
      
      deferred.resolve();
      return deferred.promise;
    };
  }

  function findTextMarker(block, marker) {
    let walk = document.createTreeWalker(
      block,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function(node) {
          if (node.textContent === marker) {
            return NodeFilter.FILTER_ACCEPT;
          }

          return NodeFilter.FILTER_REJECT;
        }
      },
      false
    );

    return walk.nextNode();
  }

  function getCaretNodeAndOffset() {
    const sel = document.getSelection();
    let node = null;

    if (sel && sel.anchorNode) {
      if (sel.anchorNode.nodeType === Node.TEXT_NODE) {
        node = sel.anchorNode.parentElement;
      } else {
        node = sel.anchorNode;
      }
    }

    if (node) {
      return { node: node.childNodes[0], offset: sel.anchorOffset };
    } else {
      return null;
    }
  }

  const SPLIT_MARKER = "!@#$";
  const SPLIT_BLOCK_DIRECTION = {
    BACKWARD: "previousSibling",
    FORWARD: "nextSibling"
  };

  function isSplitMarkerAtStart(block) {
    if (!block) {
      return false;
    }
    
    // Clone the block and remove span[list] elements to test the content
    const testBlock = block.cloneNode(true);
    const listSpans = testBlock.querySelectorAll('span[list]');
    listSpans.forEach(span => span.remove());
    
    const text = testBlock.textContent || "";
    return text.trim().startsWith(SPLIT_MARKER);
  }

  function internalSplitBlock(block, direction) {
    const marker = findTextMarker(block, SPLIT_MARKER);

    if (!marker) {
      return false;
    }

    let current = marker;
    let parent = current;

    while (current) {
      parent = current.parentElement;

      while (current[direction]) {
        current[direction].remove();
      }
      current = parent;
    }

    marker.remove();
    return true;
  }

  function insertTextAtCaret(text) {
    const location = getCaretNodeAndOffset();
    if (location) {
      let startText = location.node.textContent.substr(0, location.offset);
      let endText = location.node.textContent.substring(location.offset);

      const startNode = document.createTextNode(startText);
      const markerNode = document.createTextNode(text);
      const endNode = document.createTextNode(endText);

      location.node.parentElement.insertBefore(startNode, location.node);
      location.node.parentElement.insertBefore(markerNode, location.node);
      location.node.parentElement.insertBefore(endNode, location.node);
      location.node.remove();
      return markerNode;
    } else {
      return null;
    }
  }

  function cleanCloneNodeForJson(clone) {
    clone.querySelectorAll(".SOCE,.EOCE,.ng-scope").forEach(node => {
      if (node.classList && node.classList.contains("ng-scope")) {
        node.classList.remove("ng-scope");
      }
      if (node.classList.contains("SOCE") || node.classList.contains("EOCE")) {
        node.remove();
      }
    });

    if (
      this.blockType !== BLOCK_TYPE.PARAGRAPH &&
      this.blockType !== BLOCK_TYPE.INSERTED_LIST_ITEM_PARAGRAPH
    ) {
      const numberElement = clone.querySelector("[list]");
      let spacingElement = null;
      if (
        numberElement &&
        numberElement.nextElementSibling &&
        numberElement.nextElementSibling.style.fontSize === "7pt"
      ) {
        spacingElement = numberElement.nextElementSibling;
      }

      if (numberElement) {
        numberElement.remove();
      }

      if (spacingElement) {
        spacingElement.remove();
      }
    }

    let freeTextElements = clone.querySelectorAll("[free-text]");
    freeTextElements.forEach(freeTextNode => {
      if (freeTextNode.childNodes[0].nodeType === Node.COMMENT_NODE) {
        freeTextNode.childNodes[0].remove();
      }

      const button = freeTextNode.querySelector("button");

      if (button) {
        button.remove();
      }

      const currentContentEditable = freeTextNode.firstElementChild;

      while (currentContentEditable.childNodes.length > 0) {
        let el = currentContentEditable.childNodes[0];
        currentContentEditable.parentElement.insertBefore(
          el,
          currentContentEditable
        );
      }
      currentContentEditable.remove();

      clone.querySelectorAll("[lease-if]").forEach(ifElement => {
        ifElement.removeAttribute("data-if-id");
      });

      clone.querySelectorAll("[class]").forEach(node => {
        if (node.classList.contains("lp-hide-element")) {
          return;
        }
        if (node.classList.contains("lp-tab")) {
          // Preserve lp-tab and its modifier classes (e.g. lp-tab--leader-dots)
          const tabClasses = Array.from(node.classList).filter(
            cls => cls === 'lp-tab' || cls.startsWith('lp-tab--')
          );
          node.removeAttribute("class");
          tabClasses.forEach(cls => node.classList.add(cls));
          return;
        }
        node.removeAttribute("class");
      });

      while (clone.attributes.length > 0) {
        clone.removeAttribute(clone.attributes[0].name);
      }
    });
  }

  // public functions

  if (!Block.prototype.getInsertedListItemId) {
    Block.prototype.placeCaretAtStart = async function() {
      const firstFreeText = this.containingNode.querySelector(
        "[free-text]",
        true
      );

      await document.waitForFreeTextCompile(
        firstFreeText.getAttribute("free-text")
      );

      setTimeout(() => {
        let contentEditable = firstFreeText.querySelector("[contenteditable]");
        if (contentEditable && contentEditable.childNodes[0]) {
          let span = contentEditable.childNodes[0];
          span = LeaseEditorService.skipEmptyNodes(span, true);
          this.$scope.placeCaretAtStart(span);
        } else {
          setTimeout(this.placeCaretAtStart());
        }
      });
    };

    Block.prototype.placeCaretAtEnd = async function() {
      let lastFreeText = null;
      const list = this.containingNode.querySelectorAll("[free-text]", true);
      lastFreeText = list[list.length - 1];

      await document.waitForFreeTextCompile(
        lastFreeText.getAttribute("free-text")
      );

      setTimeout(() => {
        let contentEditable = lastFreeText.querySelector("[contenteditable]");
        if (contentEditable && contentEditable.childNodes[0]) {
          let span = contentEditable.childNodes[0];
          span = LeaseEditorService.skipEmptyNodes(span, true);
          this.$scope.placeCaretAtEnd(span);
        } else {
          setTimeout(this.placeCaretAtEnd());
        }
      });
    };

    Block.prototype.getNextVisibleBlock = function() {
      const workNode = this.tableNode || this.containingNode;

      if (!workNode) {
        return;
      }

      const walker = createVisiblePidWalker();

      // This used to locate the block by index in a full-document list. When the
      // containing node was missing from that list, indexOf returned -1 and the
      // scan restarted from the top of the document -- so an unplaced block
      // reports the document's first block as its neighbour. Leaving the walker
      // parked at the root reproduces that; the behaviour is preserved on
      // purpose, not endorsed.
      if (isVisiblePidElement(this.containingNode)) {
        walker.currentNode = this.containingNode;
      }

      let current;

      while ((current = walker.nextNode())) {
        if (
          VISIBLE_BLOCK_TAG_NAMES.indexOf(current.tagName) === -1 ||
          workNode.contains(current)
        ) {
          continue;
        }

        // There are no visible free-text elements in the next block,
        // most likely only free-text-placeholder.
        // Checked before building the block, which the old order did afterwards
        // and then discarded.
        if (!current.querySelector("[free-text]")) {
          continue;
        }

        const nextBlock = current.getBlockData();

        if (nextBlock) {
          return nextBlock;
        }
      }

      return null;
    };

    Block.prototype.getPreviousVisibleBlock = function() {
      const workNode = this.tableNode || this.containingNode;

      if (!workNode) {
        return;
      }

      // Mirrors the old index arithmetic in the other direction: a containing node
      // missing from the list gave indexOf === -1, a start index of -2, and a loop
      // that never ran.
      if (!isVisiblePidElement(this.containingNode)) {
        return null;
      }

      const walker = createVisiblePidWalker();
      walker.currentNode = this.containingNode;

      let current;

      while ((current = walker.previousNode())) {
        if (
          VISIBLE_BLOCK_TAG_NAMES.indexOf(current.tagName) === -1 ||
          workNode.contains(current)
        ) {
          continue;
        }

        const previousBlock = current.getBlockData();

        if (
          previousBlock &&
          previousBlock.containingNode !== this.containingNode
        ) {
          return previousBlock;
        }
      }

      return null;
    };

    Block.prototype.isPredefinedBlock = function() {
      const objectIndex = this.getListItemObjectIndex();
      let itemObject = this.$scope.listItems[objectIndex];
      if (itemObject && (itemObject.fromPID || itemObject.json)) {
        return true;
      } else {
        return false;
      }
    };

    Block.prototype.remove = function() {
      let getRoundTripNode = this.getRoundTripNode();
      if (getRoundTripNode) {
        getRoundTripNode.remove();
      }
      this.containingNode.remove();
    };

    Block.prototype.markAsDeletedElement = function() {
      const roundTrip = this.getRoundTripNode();
      if (roundTrip) {
        roundTrip.classList.add("deleted-element");
      }
      this.containingNode.classList.add("deleted-element");
    };

    Block.prototype.unMarkAsDeletedElement = function() {
      const roundTrip = this.getRoundTripNode();
      if (roundTrip) {
        roundTrip.classList.remove("deleted-element");
      }
      this.containingNode.classList.remove("deleted-element");
    };

    Block.prototype.getRoundTripNode = function() {
      let returnNode = null;
      if (this.containingNode && this.containingNode.previousElementSibling) {
        let prevEl = this.containingNode.previousElementSibling;
        if (
          prevEl.textContent.indexOf("!!SET_LEVEL") !== -1 &&
          prevEl.tagName === "P"
        ) {
          returnNode = prevEl;
        }
      }

      return returnNode;
    };

    Block.prototype.moveBlockElementsToTemplate = function(template) {
      const templateFreeText = template.querySelector("[free-text]");
      const numberElement = this.containingNode.querySelector("[list]");
      let spacingElement = null;
      if (
        numberElement &&
        numberElement.nextElementSibling &&
        numberElement.nextElementSibling.style.fontSize === "7pt"
      ) {
        spacingElement = numberElement.nextElementSibling;
      }

      while (templateFreeText.nextSibling) {
        templateFreeText.nextSibling.remove();
      }

      let startElement = this.containingNode;
      startElement = numberElement ? numberElement : startElement;
      startElement = spacingElement ? spacingElement : startElement;

      let moveElement = null;
      if (!numberElement && !spacingElement) {
        while (this.containingNode.childNodes.length !== 0) {
          moveElement = this.containingNode.childNodes[0];
          moveElement.remove();
          templateFreeText.parentElement.appendChild(moveElement);
        }
      } else {
        while (startElement.nextSibling) {
          moveElement = startElement.nextSibling;
          moveElement.remove();
          templateFreeText.parentElement.appendChild(moveElement);
        }
      }

      templateFreeText.remove();

      let freeTextElement = template.querySelector("[free-text]");
      if (!freeTextElement) {
        freeTextElement = template.querySelector("[free-text-placeholder]");
      }
      let pidElement = freeTextElement
        ? freeTextElement.closest("p,h1,h2,h3,h4,h5,h6")
        : null;

      if (pidElement) {
        pidElement.setAttribute("pid", this.containingNode.getAttribute("pid"));
      }
    };

    Block.prototype.getInsertedListItemId = function() {
      let workNode = null;
      let id = null;
      if (this.isInsertedListItem()) {
        if (this.tableNode) {
          workNode = this.tableNode;
        } else {
          workNode = this.containingNode;
        }
        if (workNode && workNode.hasAttribute("inserted-list-item-id")) {
          id = workNode.getAttribute("inserted-list-item-id");
        }
      }
      return id;
    };

    Block.prototype.moveToNextLevel = function() {
      if (this.canMoveToNextLevel()) {
        const nextLevel = this.listLevel.getNextLevel();

        if (nextLevel) {
          this.moveToLevel(nextLevel.level);
        }
      }
    };

    Block.prototype.moveToPreviousLevel = function() {
      if (this.canMoveToPreviousLevel()) {
        const previousLevel = this.listLevel.getPreviousLevel();

        if (previousLevel) {
          this.moveToLevel(previousLevel.level);
        }
      }
    };

    Block.prototype.getOutlineParagraphLevel = function() {
      return listItemsManager.getOutlineParagraphLevel(this.outline);      
    }

    Block.prototype.moveToLevel = function(levelName) {
      if (levelName && levelName == "paragraph") {
        levelName = this.getOutlineParagraphLevel();
      }

      if (this.canMoveToLevel(levelName)) {
        const freeText = this.containingNode.querySelector("[free-text]");
        const currentRestyle = JSON.stringify(this.$scope.lease.restyle);

        this.$scope.addToHistory({
          id: "",
          desc: "change list item level",
          redo: internalMoveToLevel(
            freeText,
            levelName,
            null,
            this.$q,
            this.$scope,
            this.LeaseEditorService
          ),
          undo: internalMoveToLevel(
            freeText,
            this.listLevel.level,
            currentRestyle,
            this.$q,
            this.$scope,
            this.LeaseEditorService
          ),
          ignoreCaret: true
        });
      } else {
        window.showUnsupportedActionMessage(
          "This action is not supported",
          8000
        );
        return;
      }
    };

    Block.prototype.getInsertedListItemIdElements = function() {
      if (this.isInsertedListItem()) {
        const workNode = this.tableNode || this.containingNode;
        const insertedListItemId = workNode.getAttribute(
          "inserted-list-item-id"
        );
        return document.querySelectorAll(
          `[inserted-list-item-id="${insertedListItemId}"]`
        );
      } else {
        return [];
      }
    };

    Block.prototype.isInsertedListItemSplitted = function() {
      if (this.isInsertedListItem()) {
        const nodeList = this.getInsertedListItemIdElements();
        const headerNode = nodeList[1];
        const bodyNode = nodeList[2];
        if (nodeList.length > 2 && headerNode.nextElementSibling !== bodyNode) {
          return true;
        }
      }
      return false;
    };

    Block.prototype.isInNestedArea = function() {
      const inNested = this.containingNode.closest(
        "[data-nested-paragraph-index]"
      );
      const hasNested = this.containingNode.querySelector(
        "[data-nested-paragraph-index]"
      );
      if (inNested || hasNested) {
        return true;
      } else {
        return false;
      }
    };

    Block.prototype.canMoveToLevel = function(levelName) {
      let answer = false;

      if (
        this.blockType === BLOCK_TYPE.NESTED_PARAGRAPH ||
        this.isInNestedArea()
      ) {
        answer = false;
      }

      let hasInsertListItemsAnywhere =
        this.$scope.features && this.$scope.features.insertListItemsAnywhere
          ? this.$scope.features.insertListItemsAnywhere
          : false;

      hasInsertListItemsAnywhere = hasInsertListItemsAnywhere || window.isDebug;
      const isInsertedListItemSplitted = this.isInsertedListItemSplitted();

      answer = answer || hasInsertListItemsAnywhere;

      if (
        this.tableNode ||
        (this.containingNode && this.containingNode.closest("table"))
      ) {
        answer = false;
      }

      if (this.listLevel) {
        let nextLevel = this.listLevel.getLevelByName(levelName);
        if (!nextLevel) {
          answer = false;
        }
        if (nextLevel.getTemplate({}).querySelector("table")) {
          answer = false;
        }
      }

      if (answer) {
        const elements = this.getInsertedListItemIdElements();
        if (elements.length > 2) {
          answer = false;
        }
      }

      return answer && !isInsertedListItemSplitted;
    };

    Block.prototype.isSplitMarkerAtStart = function() {
      const workNode = this.tableNode || this.containingNode;
      return isSplitMarkerAtStart(workNode);
    };

    Block.prototype.canMoveToNextLevel = function() {
      let nextLevel = this.listLevel ? this.listLevel.getNextLevel() : null;
      if (nextLevel) {
        return this.canMoveToLevel(nextLevel.level);
      } else {
        return false;
      }
    };

    Block.prototype.canMoveToPreviousLevel = function() {
      let previousLevel = this.listLevel
        ? this.listLevel.getPreviousLevel()
        : null;
      if (previousLevel) {
        return this.canMoveToLevel(previousLevel.level);
      } else {
        return false;
      }
    };

    Block.prototype.isInsertedListItem = function() {
      if (this.blockType.startsWith(BLOCK_TYPE.INSERTED_LIST_ITEM)) {
        return true;
      }
      return false;
    };

    Block.prototype.getListItemObjectIndex = function() {
      let returnIndex = -1;
      if (this.isInsertedListItem()) {
        let freeTextNode = this.containingNode.querySelector("[free-text]");
        let jsonId = this.containingNode.getAttribute("data-json-id");
        let pid = this.containingNode.getAttribute("pid");
        let freeText = freeTextNode
          ? freeTextNode.getAttribute("free-text")
          : null;
        let index = 0;     
        let found = false;
        
        while ( !found && index < this.$scope.listItems.length) {
          let isJsonMatch = this.$scope.listItems[index].json && this.$scope.listItems[index].jsonID === jsonId;
          if (
            this.$scope.listItems[index].headerFreeText == freeText ||
            this.$scope.listItems[index].bodyFreeText == freeText ||
            (this.$scope.listItems[index].fromPID &&
              this.$scope.listItems[index].afterFreeText === pid) ||
            (isJsonMatch)
          ) {            
            returnIndex = index;
            index++;
            if(!isJsonMatch){
              found = true;
            }
          } else {
            index++;
          }
        }
      }

      return returnIndex;
    };

    function replaceAllFreeTextIds(block, $scope) {
      block.querySelectorAll("[free-text]").forEach(freeText => {
        freeText.setAttribute("free-text", $scope.getNextFreeTextValue());
      });
      block.querySelectorAll("[free-text-placeholder]").forEach(freeText => {
        freeText.setAttribute(
          "free-text-placeholder",
          $scope.getNextFreeTextValue()
        );
      });
    }

    function getSplitBlockJson(blockJson, afterFreeText) {
      const isSubParagraph = this.isSubParagraph();
      return {
        level: isSubParagraph ? "sub-paragraph" : this.listLevel.level,
        outline: this.listLevel.outline,
        headerFreeText: $scope.getNextFreeTextValue(),
        bodyFreeText: $scope.getNextFreeTextValue(),
        afterFreeText: afterFreeText,
        fromUI: false,
        singleFT: true,
        isNewListItem: true,
        json: JSON.stringify(blockJson),
        jsonID: afterFreeText
      };
    }

    Block.prototype.cloneAndDeleteInDirection = function(anchor, isForward) {
      const textNode = document.createTextNode(SPLIT_MARKER);
      if (isForward) {
        anchor.parentElement.insertBefore(textNode, anchor);
      } else {
        anchor.parentElement.insertBefore(textNode, anchor.nextSibling);
      }
      const block1 = this.containingNode.cloneNode(true);
      textNode.remove();

      cleanCloneNodeForJson.call(this, block1);
      if (isForward) {
        internalSplitBlock(block1, SPLIT_BLOCK_DIRECTION.FORWARD);
      } else {
        internalSplitBlock(block1, SPLIT_BLOCK_DIRECTION.BACKWARD);
      }
      block1.removeWhitespace();
      replaceAllFreeTextIds(block1, this.$scope);
      const block1Json = block1.toJson();

      const sourcePid = this.containingNode.getAttribute("pid");

      let paragraphStyle = !this.getRoundTripNode()
        ? window.getRestyleObjectFromParagraph(this.containingNode, sourcePid)
        : null;

      const newListItemData = getSplitBlockJson.call(
        this,
        block1Json,
        sourcePid
      );

      return { itemObject: newListItemData, paragraphStyle: paragraphStyle };
    };

    Block.prototype.canSplit = function() {
      let hasInsertListItemsAnywhere =
        this.$scope.features && this.$scope.features.insertListItemsAnywhere
          ? this.$scope.features.insertListItemsAnywhere
          : false;

      hasInsertListItemsAnywhere = hasInsertListItemsAnywhere || window.isDebug;

      if (!hasInsertListItemsAnywhere || this.isTableListItem()) {
        return false;
      }

      if (this.containingNode.querySelector("[ng-repeat]")) {
        return false;
      }

      
      if(leaseIfManager && leaseIfManager.isInFormManager){
        if(this.containingNode.querySelector('[data-Complicated-Condition]')){
          return false;
        }
      }

      return true;
    };

    Block.prototype.splitBlock = async function() {
      try {
        
        if (window.__LEASEPILOT_IS_WORKING__) {
          return;  
        }
  
        window.__LEASEPILOT_IS_WORKING__ = true;
        
        let hasInsertListItemsAnywhere =
          this.$scope.features && this.$scope.features.insertListItemsAnywhere
            ? this.$scope.features.insertListItemsAnywhere
            : false;
  
        hasInsertListItemsAnywhere = hasInsertListItemsAnywhere || window.isDebug;
  
  
        if (!hasInsertListItemsAnywhere || this.isTableListItem() || !this.canSplit()) {
          window.showUnsupportedActionMessage(
            "This version of document does not support this action",
            8000
          );
          return;
        }
  
        if (this.containingNode.querySelector("[ng-repeat]")) {
          window.showUnsupportedActionMessage(
            "Unable to break auto-generated text",
            8000
          );
          return;
        }
        const textNode = document.createTextNode(SPLIT_MARKER);
        contentEditableManager.insertAtCaret(textNode, false);
        
        const isSplitAtStart = this.isSplitMarkerAtStart();
        const block1 = this.containingNode.cloneNode(true);
        textNode.remove();
  
        cleanCloneNodeForJson.call(this, block1);
        const block2 = block1.cloneNode(true);
  
        const freeTextArray = Array.from(
          this.containingNode.querySelectorAll("[section-id]")
        );
        let currentUndoIndex = $scope.histIndex;
        let currentListItems = JSON.parse(JSON.stringify($scope.listItems));
        const currentReStyle = JSON.parse(JSON.stringify($scope.lease.restyle));
        const currentListItemUndoTracking = JSON.parse(
          JSON.stringify($scope.listItemUndoTracking)
        );
        const currentListItemObjects = JSON.parse(
          JSON.stringify($scope.listItemObjects)
        );
        const containerElement = document.createElement("div");
        containerElement.classList.add("lp-hide-element", "lp-if-ignore");
  
        let restyleElements = JSON.parse(JSON.stringify($scope.lease.restyle));
        let listItemUndoTracking = {};
        let listItemObjects = [];
        let listItemObjectsArray = [];
  
        if (
          !internalSplitBlock(block1, SPLIT_BLOCK_DIRECTION.FORWARD) ||
          !internalSplitBlock(block2, SPLIT_BLOCK_DIRECTION.BACKWARD)
        ) {
          return;
        }

        if (isSplitAtStart) {
          // Move the bookmark from `block1` to `block2`
          const crb = block1.querySelector("crb");
          
          if (crb) {
            const crbParentElement = crb.parentElement;
            const bookmarkIndicator = crbParentElement.previousElementSibling;
            crbParentElement.remove();
            bookmarkIndicator.remove();
            block2.insertBefore(crbParentElement, block2.firstChild);
          }
        }
  
        block1.removeWhitespace();
        replaceAllFreeTextIds(block1, this.$scope);
        block2.removeWhitespace();
        replaceAllFreeTextIds(block2, this.$scope);
  
        const block1Json = block1.toJson();
        const block2Json = block2.toJson();
  
        const sourcePid = this.containingNode.getAttribute("pid");
  
        let paragraphStyle = !this.getRoundTripNode()
          ? window.getRestyleObjectFromParagraph(this.containingNode, sourcePid)
          : null;
  
        const block1PID = block1
          .querySelector("[free-text]")
          .getAttribute("free-text");
        const block2PID = block2
          .querySelector("[free-text]", true)
          .getAttribute("free-text");
  
        listItemObjectsArray.push(
          getSplitBlockJson.call(this, block1Json, sourcePid)
        );
        listItemObjectsArray.push(
          getSplitBlockJson.call(this, block2Json, block1PID)
        );
  
        listItemObjectsArray.forEach(currentListItemObject => {
          let template = listItemsManager.createListItemFromTemplate(
            currentListItemObject.level,
            this.listLevel.format,
            this.listLevel.name,
            currentListItemObject,
            true,
            false
          );
          while (template.firstElementChild) {
            let el = template.firstElementChild;
            el.remove;
            el.setAttribute(
              "inserted-list-item-id",
              this.$scope.nextUnusedListItemId
            );
            containerElement.appendChild(el);
          }
  
          listItemUndoTracking[
            `${currentListItemObject.headerFreeText}-${currentListItemObject.bodyFreeText}`
          ] = this.$scope.nextUnusedListItemId;
          listItemObjects[
            `${currentListItemObject.headerFreeText}-${currentListItemObject.bodyFreeText}`
          ] = currentListItemObject;
          this.$scope.nextUnusedListItemId++;
        });
  
        this.containingNode.parentElement.insertBefore(
          containerElement,
          this.containingNode.nextElementSibling)
  
        if (paragraphStyle) {
          restyleElements[block1PID] = paragraphStyle;
          restyleElements[block1PID].paragraphId = block1PID;
          restyleElements[block2PID] = JSON.parse(JSON.stringify(paragraphStyle));
          restyleElements[block2PID].paragraphId = block2PID;
        }
  
        const redo = function(
          restyle,
          listItemUndoTracking,
          listItemObjects,
          listItemObjectsArray,
          sourceBlock,
          containerElement,
          block2PID,
          $scope,
          stateBeforeRedo
        ) {
          return function() {
            const deferred = $q.defer();
  
            $scope.listItems = $scope.listItems.concat(listItemObjectsArray);
            $scope.lease.orderedListitem = $scope.serializeOrderedListitem();
  
            Object.keys(listItemUndoTracking).forEach(key => {
              $scope.listItemUndoTracking[key] = listItemUndoTracking[key];
            });
  
            Object.keys(listItemObjects).forEach(key => {
              $scope.listItemObjects[key] = listItemObjects[key];
            });
  
            sourceBlock.markAsDeletedElement();
  
            $scope.lease.restyle = restyle;
  
            containerElement.classList.add("lp-show-element", "diff-item");
            containerElement.classList.remove("lp-hide-element");
  
            $scope.restyle();
            setTimeout($scope.listsRefresh);
  
            $scope.update();
  
            const block = document
              .querySelector(`[pid="${block2PID}"]`)
              .getBlockData();
            block.placeCaretAtStart();
  
            deferred.resolve();
            
            setTimeout(() => {
              setTimeout(() => {
                const newBlocks = containerElement.querySelectorAll("[pid]");
                const newBlocksPids = Array.from(newBlocks).map(block => block.getAttribute("pid"));
                const stateAfterRedo = window.captureStateFromIds(newBlocksPids);
                const sourcePid = sourceBlock.containingNode.getAttribute("pid");
                
                window.track.event(new ReviseTextEvent({
                  pid: sourcePid,
                  before: stateBeforeRedo[sourcePid],
                  after: "",
                  context: $scope.$root.getContext()
                }));
                window.cachedBlocks[sourcePid] = "";
      
                Object.keys(stateAfterRedo).forEach(key => {
                  const pid = key
                  window.track.event(new ReviseTextEvent({
                    pid: pid,
                    before: "",
                    after: stateAfterRedo[pid],
                    context: $scope.$root.getContext()
                  }));
                  window.cachedBlocks[pid] = stateAfterRedo[pid];
                });
              });
            });
  
            return deferred.promise;
          };
        };
  
        const undo = function(
          restyle,
          listItemUndoTracking,
          listItemObjects,
          listItemObjectsArray,
          sourceBlock,
          containerElement,
          $scope,
          stateAfterUndo
        ) {
          return function() {
            const deferred = $q.defer();
  
            const sourcePid = sourceBlock.containingNode.getAttribute("pid");
            const newBlocks = containerElement.querySelectorAll("[pid]");
            const newBlocksPids = Array.from(newBlocks).map(block => block.getAttribute("pid"));
            const stateBeforeUndo = window.captureStateFromIds(newBlocksPids);
  
            $scope.listItems = listItemObjectsArray;
            $scope.lease.orderedListitem = $scope.serializeOrderedListitem();
  
            $scope.listItemUndoTracking = listItemUndoTracking;
            $scope.listItemObjects = listItemObjects;
            $scope.lease.restyle = restyle;
  
            sourceBlock.unMarkAsDeletedElement();
  
            containerElement.classList.remove("lp-show-element");
            containerElement.classList.add("lp-hide-element");
  
            $scope.restyle();
            setTimeout($scope.listsRefresh);
            $scope.update();
            deferred.resolve();
  
            setTimeout(() => {
              setTimeout(() => {
                Object.keys(stateBeforeUndo).forEach(key => {
                  const pid = key
                  window.track.event(new ReviseTextEvent({
                    pid: pid,
                    before: stateBeforeUndo[pid],
                    after: "",
                    context: $scope.$root.getContext()
                  }));
                  window.cachedBlocks[pid] = stateAfterUndo[pid];
                });
      
                window.track.event(new ReviseTextEvent({
                  pid: sourcePid,
                  before: "",
                  after: stateAfterUndo[sourcePid],
                  context: $scope.$root.getContext()
                }));
                window.cachedBlocks[sourcePid] = stateAfterUndo[sourcePid];
              });
            });
  
            return deferred.promise;
          };
        };
  
        const stateBeforeRedo = window.captureStateFromBlocks([this]);
        const stateAfterUndo = stateBeforeRedo;
  
        await $scope.addToHistory({
          id: "restyle split paragraph :" + sourcePid,
          desc: "restyle split paragraph ",
          redo: redo(
            restyleElements,
            listItemUndoTracking,
            listItemObjects,
            listItemObjectsArray,
            this,
            containerElement,
            block2PID,
            this.$scope,
            stateBeforeRedo
          ),
          undo: undo(
            currentReStyle,
            currentListItemUndoTracking,
            currentListItemObjects,
            currentListItems,
            this,
            containerElement,
            this.$scope,
            stateAfterUndo
          )
        });
        
        
        containerElement.querySelectorAll("[section-id]").forEach((item)=>{freeTextArray.push(item)});
        // wait for compile 
        const allFreeTextIds = freeTextArray.map((value)=>{ return value.getAttribute("section-id").replace(/{|:|}/g,'')});
        await document.waitForFreeTextCompile(allFreeTextIds);
  
        this.markAsDeletedElement();
  
        $scope.createBulk(freeTextArray);
  
        this.$scope.histRegisterBatch(
          $scope.histStack.length - 1,
          $scope.histIndex - currentUndoIndex
        );
      } catch (error) {
        console.error(error);
      } finally {
        window.__LEASEPILOT_IS_WORKING__ = false;
      }
    };

    Block.prototype.isSubParagraph = function() {
      const pidElement = this.sourceNode.closest("[pid]");
      if (
        pidElement &&
        pidElement.classList.contains("list-item-sub-paragraph")
      ) {
        return true;
      }
      return false;
    };

    Block.prototype.isTableListItem = function() {
      let answer = false;
      if (this.listLevel && this.listLevel.getTemplate) {
        const template = this.listLevel.getTemplate({});
        if (template.querySelector("table")) {
          answer = true;
        }
      }
      return answer;
    };

    Block.prototype.joinWithNextBlock = async function() {
      try {

        if (window.__LEASEPILOT_IS_WORKING__) {
          return;  
        }
  
        window.__LEASEPILOT_IS_WORKING__ = true;
  
        const nextBlock = this.getNextVisibleBlock();
  
        let hasInsertListItemsAnywhere =
          this.$scope.features && this.$scope.features.insertListItemsAnywhere
            ? this.$scope.features.insertListItemsAnywhere
            : false;
  
        hasInsertListItemsAnywhere = hasInsertListItemsAnywhere || window.isDebug;
  
        let canJoinWithTables = true;
  
        const myTableNode = this.containingNode.closest("table");
        const nextTableNode = nextBlock.containingNode.closest("table");
  
        if ((myTableNode && !nextTableNode) || (!myTableNode && nextTableNode)) {
          canJoinWithTables = false;
        }
  
        if (myTableNode && nextTableNode) {
          if (
            this.containingNode.closest("td") !==
            nextBlock.containingNode.closest("td")
          ) {
            canJoinWithTables = false;
          }
        }
  
        if (
          !hasInsertListItemsAnywhere ||
          this.isTableListItem() ||
          nextBlock.isTableListItem() ||
          !canJoinWithTables
        ) {
          window.showUnsupportedActionMessage(
            "This version of document does not support this action.",
            8000
          );
          return;
        }
  
        if(leaseIfManager && leaseIfManager.isInFormManager){
          if(this.containingNode.querySelector('[data-Complicated-Condition]') ||
          nextBlock.containingNode.querySelector('[data-Complicated-Condition]')  ){
            window.showUnsupportedActionMessage(
              "This action is not supported using the Form Manager, please submit a change request to support@leasepilot.co",
              8000
            );
            return;
          }
        }
  
        if (
          this.containingNode.querySelector("[ng-repeat]") ||
          nextBlock.containingNode.querySelector("[ng-repeat]")
        ) {
          window.showUnsupportedActionMessage(
            "Unable to join auto-generated text",
            8000
          );
          return;
        }
  
        const firstBlock = this.containingNode.cloneNode(true);
        const secondBlock = nextBlock.containingNode.cloneNode(true);
  
        const firstBlockFreeTextArray = Array.from(
          firstBlock.querySelectorAll("[section-id]")
        );
  
        const secondBlockFreeTextArray = Array.from(
          secondBlock.querySelectorAll("[section-id]")
        );
  
        const freeTextArray = firstBlockFreeTextArray.concat(
          secondBlockFreeTextArray
        );
  
        const blockElements = [this, nextBlock];
  
        const newBlockForJson = document.createElement("div");
        const sourcePid = this.containingNode.getAttribute("pid");
        const containerElement = document.createElement("div");
        containerElement.classList.add("lp-hide-element");
  
        let currentUndoIndex = $scope.histIndex;
        let currentListItems = JSON.parse(JSON.stringify($scope.listItems));
        const currentReStyle = JSON.parse(JSON.stringify($scope.lease.restyle));
        const currentListItemUndoTracking = JSON.parse(
          JSON.stringify($scope.listItemUndoTracking)
        );
        const currentListItemObjects = JSON.parse(
          JSON.stringify($scope.listItemObjects)
        );
  
        let restyleElements = JSON.parse(JSON.stringify($scope.lease.restyle));
        let listItemUndoTracking = {};
        let listItemObjects = [];
        let listItemObjectsArray = [];
  
        cleanCloneNodeForJson.call(this, firstBlock);
        cleanCloneNodeForJson.call(this, secondBlock);
  
        firstBlock.removeWhitespace();
        replaceAllFreeTextIds(firstBlock, this.$scope);
        secondBlock.removeWhitespace();
        replaceAllFreeTextIds(secondBlock, this.$scope);
        const caretFreeText = secondBlock
          .querySelector("[free-text]")
          .getAttribute("free-text");
  
        let moveNode = null;
        while (firstBlock.childNodes.length !== 0) {
          moveNode = firstBlock.childNodes[0];
          moveNode.remove();
          newBlockForJson.appendChild(moveNode);
        }
  
        if (moveNode && moveNode.tagName === "HARD-RETURN") {
          moveNode.remove();
        }
  
        while (secondBlock.childNodes.length !== 0) {
          moveNode = secondBlock.childNodes[0];
          moveNode.remove();
          newBlockForJson.appendChild(moveNode);
        }
  
        const newPid = newBlockForJson
          .querySelector("[free-text]")
          .getAttribute("free-text");
  
        const newBlockJson = newBlockForJson.toJson();
  
        let paragraphStyle =
          this.containingNode.tagName === "P"
            ? window.getRestyleObjectFromParagraph(this.containingNode, newPid)
            : null;
  
        listItemObjectsArray.push(
          getSplitBlockJson.call(this, newBlockJson, sourcePid)
        );
  
        listItemObjectsArray.forEach(currentListItemObject => {
          let template = listItemsManager.createListItemFromTemplate(
            currentListItemObject.level,
            this.listLevel.format,
            this.listLevel.name,
            currentListItemObject,
            true,
            false
          );
          while (template.firstElementChild) {
            let el = template.firstElementChild;
            el.remove;
            el.setAttribute(
              "inserted-list-item-id",
              this.$scope.nextUnusedListItemId
            );
            containerElement.appendChild(el);
          }
  
          listItemUndoTracking[
            `${currentListItemObject.headerFreeText}-${currentListItemObject.bodyFreeText}`
          ] = this.$scope.nextUnusedListItemId;
          listItemObjects[
            `${currentListItemObject.headerFreeText}-${currentListItemObject.bodyFreeText}`
          ] = currentListItemObject;
          this.$scope.nextUnusedListItemId++;
        });
  
        this.containingNode.parentElement.insertBefore(
          containerElement,
          this.containingNode.nextElementSibling
        );
  
        // add undo redo:
        if (paragraphStyle) {
          restyleElements[newPid] = paragraphStyle;
          restyleElements[newPid].paragraphId = newPid;
        }
  
        const redo = function(
          restyle,
          listItemUndoTracking,
          listItemObjects,
          listItemObjectsArray,
          blockElements,
          containerElement,
          caretFreeText,
          $scope,
          stateBeforeRedo
        ) {
          return function() {
            const deferred = $q.defer();
  
            $scope.listItems = $scope.listItems.concat(listItemObjectsArray);
            $scope.lease.orderedListitem = $scope.serializeOrderedListitem();
  
            Object.keys(listItemUndoTracking).forEach(key => {
              $scope.listItemUndoTracking[key] = listItemUndoTracking[key];
            });
  
            Object.keys(listItemObjects).forEach(key => {
              $scope.listItemObjects[key] = listItemObjects[key];
            });
  
            $scope.lease.restyle = restyle;
  
            blockElements.forEach(del => {
              del.markAsDeletedElement();
            });
  
            containerElement.classList.add("lp-show-element");
            containerElement.classList.remove("lp-hide-element");
  
            $scope.restyle();
            setTimeout($scope.listsRefresh);
            $scope.update();
  
            //caretFreeText
  
            const caretNode = document.querySelector(
              `[free-text="${caretFreeText}"]`
            );
  
            let contentEditable = caretNode.querySelector("[contenteditable]");
  
            contentEditable.setAttribute("contenteditable", true);
  
            if (contentEditable && contentEditable.childNodes[0]) {
              let span = contentEditable.childNodes[0];
              span = LeaseEditorService.skipEmptyNodes(span, true);
              $scope.placeCaretAtStart(span);
            }
  
            deferred.resolve();
  
            setTimeout(() => {
              setTimeout(() => {
                const newBlock = containerElement.querySelector("[pid]");
                const newBlockId = newBlock.getAttribute("pid");
                const blocks = [...blockElements, newBlock.getBlockData()];
                const stateAfterRedo = window.captureStateFromBlocks(blocks);
                
                Object.keys(stateBeforeRedo).forEach(key => {
                  const pid = key
                  window.track.event(new ReviseTextEvent({
                    pid: pid,
                    before: stateBeforeRedo[pid],
                    after: "",
                    context: $scope.$root.getContext()
                  }));
                  window.cachedBlocks[pid] = "";
                });
  
                window.track.event(new ReviseTextEvent({
                  pid: newBlockId,
                  before: "",
                  after: stateAfterRedo[newBlockId],
                  context: $scope.$root.getContext()
                }));
                window.cachedBlocks[newBlockId] = stateAfterRedo[newBlockId];
              });
            });
            
            return deferred.promise;
          };
        };
  
        const undo = function(
          restyle,
          listItemUndoTracking,
          listItemObjects,
          listItemObjectsArray,
          blockElements,
          containerElement,
          $scope,
          stateAfterUndo
        ) {
          return function() {
            const deferred = $q.defer();

            const newBlock = containerElement.querySelector("[pid]");
            const newBlockId = newBlock.getAttribute("pid");
            const blocks = [...blockElements, newBlock.getBlockData()];
            const stateBeforeUndo = window.captureStateFromBlocks(blocks);
  
            $scope.listItems = listItemObjectsArray;
            $scope.lease.orderedListitem = $scope.serializeOrderedListitem();
  
            $scope.listItemUndoTracking = listItemUndoTracking;
            $scope.listItemObjects = listItemObjects;
            $scope.lease.restyle = restyle;
  
            blockElements.forEach(del => {
              del.unMarkAsDeletedElement();
            });
  
            containerElement.classList.remove("lp-show-element");
            containerElement.classList.add("lp-hide-element");
  
            $scope.restyle();
            setTimeout($scope.listsRefresh);
            $scope.update();
            deferred.resolve();
  
            setTimeout(() => {
              setTimeout(() => {
                Object.keys(stateAfterUndo).forEach(key => {
                  const pid = key
                  window.track.event(new ReviseTextEvent({
                    pid: pid,
                    before: "",
                    after: stateAfterUndo[pid],
                    context: $scope.$root.getContext()
                  }));
                  window.cachedBlocks[pid] = stateAfterUndo[pid];
                });
  
                window.track.event(new ReviseTextEvent({
                  pid: newBlockId,
                  before: stateBeforeUndo[newBlockId],
                  after: "",
                  context: $scope.$root.getContext()
                }));
                window.cachedBlocks[newBlockId] = stateAfterUndo[newBlockId];
              });
            });
  
            return deferred.promise;
          };
        };
  
        await document.waitForFreeTextCompile(caretFreeText);
  
        const stateBeforeRedo = window.captureStateFromBlocks(blockElements);
        const stateAfterUndo = stateBeforeRedo;
  
        await $scope.addToHistory({
          id: "restyle split paragraph :" + sourcePid,
          desc: "restyle split paragraph ",
          redo: redo(
            restyleElements,
            listItemUndoTracking,
            listItemObjects,
            listItemObjectsArray,
            blockElements,
            containerElement,
            caretFreeText,
            this.$scope,
            stateBeforeRedo
          ),
          undo: undo(
            currentReStyle,
            currentListItemUndoTracking,
            currentListItemObjects,
            currentListItems,
            blockElements,
            containerElement,
            this.$scope,
            stateAfterUndo
          ),
          ignoreCaret: true
        });
  
  
        containerElement.querySelectorAll("[section-id]").forEach((item)=>{freeTextArray.push(item)});
        // wait for compile 
        const allFreeTextIds = freeTextArray.map((value)=>{ return value.getAttribute("section-id").replace(/{|:|}/g,'')});
        await document.waitForFreeTextCompile(allFreeTextIds);
  
        blockElements.forEach(del => {
          del.markAsDeletedElement();
        });
  
        $scope.createBulk(freeTextArray);
  
        this.$scope.histRegisterBatch(
          $scope.histStack.length - 1,
          $scope.histIndex - currentUndoIndex
        );
      } catch (error) {
        console.error(error);
      } finally {
        window.__LEASEPILOT_IS_WORKING__ = false;
      }
    };

    Block.prototype.moveToElement = function(element) {
      const roundTripNode = this.getRoundTripNode();
      const workNode = this.tableNode || this.containingNode;
      if (roundTripNode && workNode.contains(roundTripNode)) {
        workNode.remove();
        element.appendChild(workNode);
      } else {
        if (roundTripNode) {
          roundTripNode.remove();
          element.appendChild(roundTripNode);
        }

        element.appendChild(workNode);
      }
    };

    Block.prototype.addNextBlock = async function() {
      const sel = document.getSelection();
      let node = null;
      if (sel && sel.anchorNode) {
        if (sel.anchorNode.nodeType === Node.TEXT_NODE) {
          node = sel.anchorNode.parentElement;
        } else {
          node = sel.anchorNode;
        }
      }

      if (node) {
        const tblNode = node.closest("table");
        let paragraphStyle = null;
        const currentUndoIndex = $scope.histIndex;
        const currentReStyle = JSON.stringify(this.$scope.lease.restyle);

        let itemObject = {
          level: null,
          outline: null,
          headerFreeText: this.$scope.getNextFreeTextValue(),
          bodyFreeText: this.$scope.getNextFreeTextValue(),
          afterFreeText: null,
          fromUI: true,
          singleFT: true,
          isNewListItem: true
        };

        if (tblNode === null) {
          itemObject.level = this.listLevel.level;
          itemObject.outline = this.listLevel.outline;
          itemObject.afterFreeText = this.containingNode.getAttribute("pid");
          itemObject.index = this.containingNode.getNodeOccurrenceIndexByAttribute(
            "pid"
          );
          this.$scope.listsNewListItem(null, itemObject, null, null, true);

          if (itemObject.level === "paragraph") {
            paragraphStyle = window.getRestyleObjectFromParagraph(
              this.containingNode,
              this.containingNode.getAttribute(itemObject.headerFreeText)
            );
          }
        } else {
          const subParagraphAnchor = node.parentElement;
          itemObject.level = "sub-paragraph";
          itemObject.outline = this.listLevel ? this.listLevel.outline : null;
          itemObject.afterFreeText = node
            .closest("[section-id]")
            .getAttribute("section-id");
          itemObject.index = node
            .closest("[free-text]")
            .getNodeOccurrenceIndexByAttribute("pid");
          itemObject.fromUI = false;

          this.$scope.listsNewListItem(null, itemObject, null, null, true);

          paragraphStyle = window.getRestyleObjectFromParagraph(
            subParagraphAnchor.closest("p,h1,h2,h3,h4,h5,h6"),
            this.containingNode.getAttribute(itemObject.headerFreeText)
          );
        }

        if (paragraphStyle) {
          const redoStyle = function(styleObject, pid, $scope) {
            return function() {
              const deferred = $q.defer();
              $scope.lease.restyle[pid] = styleObject;
              $scope.restyle();
              $scope.update();
              deferred.resolve();
              return deferred.promise;
            };
          };

          const undoStyle = function(restyle, $scope) {
            return function() {
              const deferred = $q.defer();
              $scope.lease.restyle = JSON.parse(restyle);
              $scope.restyle();
              $scope.update();
              deferred.resolve();
              return deferred.promise;
            };
          };

          await $scope.addToHistory({
            id: "restyle new list item paragraph :" + itemObject.afterFreeText,
            desc: "restyle new list item paragraph ",
            redo: redoStyle(
              paragraphStyle,
              itemObject.headerFreeText,
              this.$scope
            ),
            undo: undoStyle(currentReStyle, this.$scope)
          });

          $scope.histRegisterBatch(
            $scope.histStack.length - 1,
            $scope.histIndex - currentUndoIndex
          );
        }
      }
    };

    Block.prototype.isEmpty = function() {
      return applyFilterVisible(() => {
        return !this.$scope.$root.listItemHasContent(
          $(this.tableNode || this.containingNode)
        );
      });
    };

    Block.prototype.isFullySelected = function() {
      const sel = rangy.getSelection();
      const range = sel.getRangeAt(0);
      const textNodes = this.getAllEditableTextNodes();

      if (textNodes.length === 0) {
        range.containsNode(this.sourceNode)
      } else {
        for (let i = 0; i < textNodes.length; i++) {
          if (
            textNodes[i].parentNode.tagName !== "START-MARKER" &&
            textNodes[i].parentNode.tagName !== "END-MARKER" &&
            !range.containsNode(textNodes[i])
          ) {
            return false;
          }
        }
  
        return true;
      }
    };

    Block.prototype.getAllEditableTextNodes = function() {
      let iterator;
      let result = [];

      if (!this.containingNode) {
        return result;
      }

      let walk = document.createTreeWalker(
        this.containingNode,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function(node) {
            const parentNode = node.parentElement;
            const isEditable = parentNode.closest(".editable");
            const isSOCE = parentNode.classList.contains("SOCE");
            const isEmptyPlaceholder =
              parentNode.classList.contains("PLACEHOLDER") &&
              (node.textContent === window.CONSTS.SPECIAL_CHARS.ZERO_WIDTH_NO_BREAKING_SPACE || node.textContent === window.CONSTS.SPECIAL_CHARS.ZERO_WIDTH_SPACE);
            const isEOCE = parentNode.classList.contains("EOCE");
            const isSkip = parentNode.classList.contains("SKIP");
            const isListPadding =
              parentNode.classList.contains("word-indent") &&
              parentNode.style.font.indexOf("7pt") !== -1;
            const isRangyBoundary = parentNode.classList.contains("rangySelectionBoundary");
            const isStartMarker = parentNode.tagName === "START-MARKER";
            const isEndMarker = parentNode.tagName === "END-MARKER";

            if (
              isEditable &&
              !isSOCE &&
              !isEmptyPlaceholder &&
              !isEOCE &&
              !isSkip &&
              !isListPadding && 
              !isRangyBoundary &&
              !isStartMarker &&
              !isEndMarker
            ) {
              return NodeFilter.FILTER_ACCEPT;
            } else {
              return NodeFilter.FILTER_REJECT;
            }
          }
        },
        false
      );

      while ((iterator = walk.nextNode())) {
        if (
          iterator.parentElement.closest(".editable") &&
          !iterator.parentElement.closest(".lp-hide")
        ) {
          result.push(iterator);
        }
      }

      return result;
    };

    Block.prototype.getLastTextNode = function() {
      //previousElementSibling
      const eoceList = this.containingNode.querySelectorAll(".EOCE", true);

      if (eoceList && eoceList.length > 0) {
        const lastSpan = eoceList[eoceList.length - 1].previousElementSibling;
        return lastSpan.childNodes[lastSpan.childNodes.length - 1];
      } else {
        return null;
      }
    };

    Block.prototype.getFirstTextNode = function() {
      const firstSpan = this.containingNode.querySelector(".SOCE", true)
        .nextElementSibling;

      if (firstSpan) {
        return firstSpan.childNodes[0];
      } else {
        return null;
      }
    };

    Block.prototype.isInViewport = function() {
      const element = this.containingNode;
      const rect = element.getBoundingClientRect();
      const html = document.documentElement;
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || html.clientHeight) &&
        rect.right <= (window.innerWidth || html.clientWidth)
      );
    };

    Block.prototype.scrollTo = function(behavior = "smooth", block = "center") {
      const element = this.containingNode;

      if (!this.isInViewport()) {
        element.scrollIntoViewIfNeeded({
          behavior,
          block
        });
      }
    };
  }
}

window.Block = Block;
window.BLOCK_TYPE = BLOCK_TYPE;
